/**
 * Widget Default Configurations
 * Contains default configuration values for each widget type
 */

import { DATE_FORMATS } from './constants';

/**
 * Default configurations for each widget type
 */
export const widgetDefaults = {
  kpi: {
    format: 'currency',
    style: 'small',
    backgroundColor: 'lightblue10',
    showChange: false
  },

  table: {
    grouping: 'service',
    valueName: 'cost',
    showTitle: true,
    showIcons: false
  },

  areachart: {
    dateFormat: DATE_FORMATS.SHORT,
    stacked: false,
    showButtons: true,
    legendPosition: 'bottom'
  },

  barchart: {
    valueName: 'Total Costs',
    dateFormat: DATE_FORMATS.LONG,
    showButtons: true,
    legendPosition: 'right'
  },

  donutchart: {
    nameKey: 'name',
    valueKey: 'value',
    format: 'currency',
    subtitle: ''
  },

  sectionbreak: {
    title: ''
  },

  forecastchart: {
    dateFormat: DATE_FORMATS.SHORT,
    dateGrouping: { label: "Day", value: "MMM D" },
    showButtons: true,
    stacked: true,
    valueName: "Total Costs",
    selectedSeries: null,
    availableSeries: [],
    forecastType: "cost",
    selectedProduct: null,
    showPreviousMonth: true,
    showNextMonth: true
  },

  forecasttable: {
    dateFormat: DATE_FORMATS.SHORT,
    dateGrouping: { label: "Day", value: "MMM D" },
    grouping: "Resource",
    showIcons: false
  },

  resourcechangestrend: {
    title: 'Resource Changes Trend'
  },

  resourcechangesoverview: {
    title: 'Resource Changes Overview',
    hideZeroNetChangeClusters: true,
    selectedClusters: [],
    clusterOrder: []
  },

  resourceoverview: {
    title: 'Resource Overview',
    selectedClusters: [],
    clusterOrder: []
  },

  resourcelist: {
    title: 'Resource List',
    displayLevel: 'first',
    selectedClusters: [],
    showIcons: false
  },

  resourceutilization: {
    title: 'Resource Utilization',
    selectedResourceId: '',
    selectedResourceName: '',
    measure: 'cpu_utilization'
  },

  insighttable: {
    title: 'Insights',
    showTitle: true,
    insightTypes: [],
    measures: [],
    showIcons: false
  },

  costtrendchart: {
    title: 'Cost Trend',
    grouping: 'cost_resource_type',
    dateFormat: DATE_FORMATS.SHORT,
    stacked: true,
    showButtons: true,
    legendPosition: 'bottom',
    showLegend: true,
    dateGrouping: { label: "Day", value: "MMM D" }
  }
};

/**
 * Get default configuration for a widget type
 * @param {string} type - Widget type
 * @returns {Object} - Default configuration
 */
export const getDefaultConfig = (type) => {
  return widgetDefaults[type] ? { ...widgetDefaults[type] } : {};
};

export default widgetDefaults;

